import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReportParams } from 'src/app/reporting-system/components/generate-reports/generate-reports.component';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { GenericApiResponse } from '../interfaces/api';

@Injectable({
  providedIn: 'root',
})
export default class ReportsService {
  constructor(
    private readonly http: HttpClient,
    private readonly api: ApiService
  ) {}

  public getPremiumPartners(): Observable<
    GenericApiResponse<PremiumPartner[]>
  > {
    const endpoint = `${this.api.url}/admin/user-report/premium-partners`;
    return this.http.get<GenericApiResponse<PremiumPartner[]>>(endpoint);
  }

  public generateReport(reportParams: ReportParams): Observable<any> {
    return this.http.post(
      `${this.api.url}/admin/user-report/generate`,
      reportParams
    );
  }

  public generateProviderMovementReport(
    reportParams: ReportParams
  ): Observable<any> {
    return this.http.post(
      `${this.api.url}/admin/user-report/changes-generate`,
      reportParams
    );
  }
}

export type PremiumPartner = {
  uuid: string;
  name: string;
};
